import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommentaireService} from '../../../services/commentaire.service';
import {Commentaire} from '../../../classes/commentaire';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Role} from '../../../../identite/shared/classes/role';

@Component({
  selector: 'app-commentaire-form',
  templateUrl: './commentaire-form.component.html',
  styleUrls: ['./commentaire-form.component.css']
})
export class CommentaireFormComponent implements OnInit {
  @Input() resourceType;
  @Input() resourceId;

  @Output() submitEvent = new EventEmitter<Commentaire>();

  formGroup: FormGroup;
  currentUser: Role = null;

  constructor(
  ) { }

  ngOnInit() {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.initFormGroup();
  }

  initFormGroup() {
    this.formGroup = new FormGroup({
      body: new FormControl('', Validators.required)
    });
  }

  get body() {
    return this.formGroup.get('body');
  }

  onSubmit() {
    const commentaire = new Commentaire();

    commentaire.content = {body: this.body.value};
    commentaire.com_roles_id = this.currentUser ? this.currentUser.id : null;
    commentaire.com_ressource_id = this.resourceId;
    commentaire.com_ressource_type = this.resourceType;

    this.submitEvent.emit(commentaire);
    this.body.setValue('');
  }
}
